import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import { useNavigate } from "react-router-dom";

export default function CategoriesSct({ categories = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const items = categories?.categorys?.map((cat, index) => {
    if (index < 4) {
      return (
        <Stack
          onClick={() => navigate(`/products/${cat?.code}`)}
          key={cat?.code}
          sx={{
            width: { xs: "120px", sm: "130px", md: "220px", xxl: "250px" },
            height: { xs: "120px", sm: "130px", md: "220px", xxl: "250px" },
            // bgcolor: "#f5f5f5",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "0.3s",
            position: "relative",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "1.5rem",
              overflow: "hidden",
              backdropFilter: "blur(12px)",
              backgroundColor: "transparent",
            }}
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={
                cat?.icon?.file_name
                  ? import.meta.env.VITE_URL + cat?.icon?.file_name
                  : "/Media/nimobileIcon.png"
              }
              alt={cat?.icon?.file_name}
              title={cat?.title?.alt}
            />
          </Box>
          <GradientBorderBox
            bgGrad="linear-gradient(
    135deg,
    #000000ff -30%,
    #313131 50%,
     #313131 130%
  )"
          />
          <BorderedButton
            sx={{
              position: "absolute",
              backgroundColor: theme.palette.primary.lowOpacity,
              width: "110%",
              color: "white",
              fontWeight: "bold",
              top: "70%",
              height: { xs: "30px", lg: "50px" },
            }}
            icon={false}
          >
            {cat?.name}
          </BorderedButton>
        </Stack>
      );
    }
  });
  return (
    <Container maxWidth={"xxl"} sx={{ pb: "7rem" }}>
      {/* Cats */}
      <Stack
        direction="row"
        sx={{
          gap: "2.5rem",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {items}
      </Stack>
    </Container>
  );
}
